import { FC, useEffect, useState } from 'react';

import { ReactComponent as ArrowUp } from '../../assets/icons/arrowUp.svg';

import './Button.sass';
import { CustomButton } from './index';

interface IUpButtonProps {
  className?: string;
}

// Страница публикаций
export const UpButton: FC<IUpButtonProps> = ({ className }) => {
  const [showUpButton, setShowUpButton] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 362) {
        setShowUpButton(true);
      } else {
        setShowUpButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <div
      className={
        `up-button-wrapper ${className}` + (showUpButton ? '' : ' hidden')
      }
    >
      <CustomButton
        variant="orange-transparent"
        className={`up-button ${className}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <ArrowUp />
      </CustomButton>
    </div>
  );
};
